<template>
    <div class="flex-fill flex-column d-flex" style="background: #fff;">
        <fe-grid ref="grid" style="height:100%;"
            :columnDefs="mergedDefs"
            :rowData="rowData"
            :showAddRowBtn="false"
            domLayout="normal"
            displayDensity="medium"
            @selection-changed="onSelect"
            @cellMouseOver="doCellOver"
            @cellMouseOut="doCellOut"
            exportFilename="Students 3D"
            :grouped="rowGroup"
            :csvExportProcessCellCallback="processCsvCell"
        >
            <template v-slot:toolbar-items>
                <fe-btn data-test="students3d-apply-tag-btn" :disabled="!selection.length" usage="secondary" @click="tagStudents">Apply Tag</fe-btn>
                <fe-btn data-test="students3d-create-intervention-btn" :disabled="!selection.length" usage="secondary" @click="createIntervention">Intervention</fe-btn>
            </template>
        </fe-grid>

        <fe-student-card
            ref="studentCard"
            :style="{
                position: 'absolute',
                left: `${studentCard.left}px`,
                top: `${studentCard.top}px`,
                padding: '1px 6px 1px 6px',
                zIndex: '10'
            }"
            :imageUrl="studentCard.imageUrl"
            :studentRecord="studentCard.studentRecord"
            v-show="studentCard.show"
            fullNameField="student_full_name"
            schoolField="school_name"
            gradeField="grade_desc"
            genderField="gender"
            @close="() => {}"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { mapLocalState } from '@/util/vuexHelper'
import * as Util from '../Util'
import studentProfileMixin from '@/mixins/studentProfile'
import FullScreenIntervention from '@/components/modules/intervention/creation/fullscreen/index'

export default {
    name: 'Grid',

    inject: ['localStore'],

    mixins: [ studentProfileMixin ],

    components: {
        FullScreenIntervention,
    },

    props: {
        selectedOnly: {type: Boolean, default: false},
        rowGroup: {type: Boolean, default: false},
    },

    data() {
        return {
            selection: [],
            filterDefs: [],
            rowData: [],
            columnDefs: [{
                checkboxSelection: true,
                minWidth: 70,
                width: 70,
                headerCheckboxSelection: true,
                colId: 'checkbox_column'
            }, {
                headerName: 'Student Name',
                field: 'student_full_name',
                width: 200,
                sortable: true,
                onCellClicked: v => {
                    this.goToStudentProfile(v.data.student_id)
                }
            }, {
                headerName: 'EduCLIMBER ID',
                field: 'student_id',
                width: 150,
                sortable: true,
                hide: true,
            }, {
                headerName: 'District ID',
                field: 'student_district_id',
                width: 150,
                sortable: true,
                hide: true,
            }, {
                headerName: 'School',
                field: 'school_name',
                sortable: true
            }, {
                headerName: 'Grade',
                field: 'grade_desc',
                sortable: true, width: 150
            }, {
                headerName: 'Gender',
                field: 'gender',
                sortable: true,
                width: 150
            }, {
                headerName: 'Ethnicity',
                field: 'ethnicity',
                sortable: true
            }, {
                headerName: 'Group',
                field: 'group_name',
                rowGroup: this.rowGroup,
                sortable: true,
                hide: true,
            }],
        }
    },

    computed: {
        ...mapState('global',['sessionUser']),

        ...mapLocalState(['activeGrouping','params', 'selectedStudents','vueLoaderId']),

        mergedDefs() {
            return [...this.columnDefs, ...this.filterDefs]
        },
    },

    mounted() {
        this.$refs.grid.gridOptions.groupUseEntireRow = true

        this.getData()

        // Add data-test attributes to fe-grid internal elements
        this.$nextTick(() => {
            this.addDataTestAttributes()
        })
    },

    watch: {
        // Mirrors Renderer.vue's watcher for the chart view, so the Data Wall stays in sync.
        activeGrouping() {
            this.getData()
        },
    },

    methods: {
        addDataTestAttributes() {
            // Add data-test attributes to fe-grid internal toolbar elements
            // These elements are rendered by the fe-grid component from the external library
            if (this.$refs.grid && this.$refs.grid.$el) {
                const gridEl = this.$refs.grid.$el
                
                // Find and tag the search/filter input
                const searchInput = gridEl.querySelector('input[type="text"][placeholder*="ilter"], input[type="text"][aria-label*="ilter"]')
                if (searchInput) {
                    searchInput.setAttribute('data-test', 'students3d-search-bar')
                }
                
                // Find and tag the download/export button (usually has export icon or text)
                const downloadBtn = gridEl.querySelector('button[title*="xport"], button[aria-label*="xport"], i.fa-download')
                if (downloadBtn) {
                    const btn = downloadBtn.tagName === 'BUTTON' ? downloadBtn : downloadBtn.closest('button')
                    if (btn) btn.setAttribute('data-test', 'students3d-download-csv-btn')
                }
                
                // Find and tag the settings/cogwheel button
                const settingsBtn = gridEl.querySelector('button[title*="etting"], button[aria-label*="etting"], i.fa-cog, i.fa-gear')
                if (settingsBtn) {
                    const btn = settingsBtn.tagName === 'BUTTON' ? settingsBtn : settingsBtn.closest('button')
                    if (btn) btn.setAttribute('data-test', 'students3d-settings-btn')
                }
            }
        },
        
        onSelect() {
            let api = this.$refs.grid.gridApi
            this.selection = api.getSelectedRows()
        },

        tagStudents() {
            this.$tagStudents(true, this.selection, ()=> {})
        },

        createIntervention() {
            if(this.$parent.$options.name !== 'MainPanel') this.selectedStudents = []

            this.studentCard.show = false
            let params = {
                height: '96%',
                width: '96%',
                class: 'fullscreen-intervention-modal',
                modal: true,
                ref: 'fullscreenIntervention',
                attrs: {
                    fastbridgeMonitor: {}, 
                    students: this.selection
                }
            } 
            this.$dockableIntervention(params)
        },

        emitEcEvent(action) {
            let target = '*'
            let msgData = JSON.stringify({
                identifier: this.vueLoaderId,
                action: action,
                data: JSON.stringify(this.selection)
            })
            window.parent.postMessage(msgData,target)
         },

        async getScoreDetailType() {
            for (let f in this.params.filters) {
                let filter = this.params.filters[f]
                if (filter.params.score_detail_type_id) {
                    await this.$modelGet('scoreDetailType', { id: filter.params.score_detail_type_id })
                        .then(r => {
                            filter['score_detail_type'] = r[0].code
                        })
                }
            }
        },

        async getData() {
            let filterDefs = {}
            let recs = []
            let selectedIndex = {}
            let selectedStudents = this.selectedStudents.forEach ? this.selectedStudents : [this.selectedStudents]
            selectedStudents.forEach(x => selectedIndex[x.student_id] = true)

            await this.getScoreDetailType()

            this.activeGrouping.groups.forEach(group => {
                group.data.forEach(x => {
                    if(this.selectedOnly && !selectedIndex[x.student_id]) return

                    // filter to unique only if this a selection
                    if(this.selectedOnly) selectedIndex[x.student_id] = false

                    // assemble the data
                    let data = {
                        group_name: group.name,
                        student_id: x.student_id,
                        student_full_name: x.student_full_name,
                        student_district_id: x.student_district_id,
                        school_name: x.school_name,
                        grade_desc: x.grade_desc,
                        gender: x.gender,
                        ethnicity: x.ethnicity,
                        id: x.student_id,
                        school_year_id: x.school_year_id
                    }

                    // get the extra text that's contained in the filters
                    Util.studentFilterText(this, this.params.filters, x).forEach(f => {
                        if(f.name) {
                            let field = 'filter_' + f.name.replace(/\W/g,'') + (f.detail ? f.detail.replace(/\s+/g, '') : '')
                            let name = !f.detail ? f.name : f.name + ' (' + f.detail + ')'
                            data[field] = f.value
                            if(!filterDefs[field]) {
                                filterDefs[field] = {
                                    headerName: name,
                                    field: field,
                                    sortable: true,
                                    valueGetter(v) {
                                        if (v.data && v.data[field]) {
                                            // get numeric part of value, if exists, for sorting
                                            let number = v.data[field].replace(/[^0-9.]/g, '')
                                            if (isNaN(parseFloat(number))) {
                                                return v.data[field]
                                            } else {
                                                return parseFloat(number)
                                            }
                                        }
                                    },
                                    cellRenderer(v) {
                                        // display full alphanumeric score display (i.e. lexile score of 1340L))
                                        return v.data[field]
                                    },
                                }
                            }
                        }
                    })
                    recs.push(Object.freeze(data))
                })
            })
            this.filterDefs = Object.values(filterDefs)

            this.rowData = recs
        },

        processCsvCell(params) {
            // Add student count to school name header
            if (this.activeGrouping.type === 'school_id' && params.node?.group) {
                if (params.column.colId === 'checkbox_column') {
                    const group = this.activeGrouping.groups.find(g => params.value === ` -> ${g.name}`)
                    if (group) {
                        return `${params.value} (${group.data.length})`
                    }
                }
            }
            return params.value
        },
    },
}
</script>

<style lang="scss" scoped>
</style>
